import { TenantPackageConfig } from '~/tenants/common/registry';
import { McmOrderContext } from '~/tenants/mcm/model/McmOrder';
import dedent from 'dedent';
import McmPhotoConfig from '~/tenants/mcm/performable/photo/McmPhotoConfig';
import McmVideoConfig, { McmVideoType } from '~/tenants/mcm/performable/video/McmVideoConfig';
import McmVirtualConfig from '~/tenants/mcm/performable/virtual/McmVirtualConfig';

const McmPackageHighlight: TenantPackageConfig<McmOrderContext> = {
  id: 'highlight',
  name: 'Highlight',
  performables: [
    McmPhotoConfig,
    McmVirtualConfig,
    {
      config: McmVideoConfig,
      metadata: {
        type: McmVideoType.HIGHLIGHT,
      },
    },
  ],
  eligible: ({ buyer, parent }) => !Boolean(buyer.metadata.crossroads || parent?.crossroads),
  description: '',
  amount: '29.95',
};

export default McmPackageHighlight;
